import { render, staticRenderFns } from "./AdjustResultBtnAdmin.vue?vue&type=template&id=037ca4e2&scoped=true&"
import script from "./AdjustResultBtnAdmin.vue?vue&type=script&lang=js&"
export * from "./AdjustResultBtnAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AdjustResultBtnAdmin.vue?vue&type=style&index=0&id=037ca4e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037ca4e2",
  null
  
)

export default component.exports